<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <v-form v-model="valid" ref="form">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>THÔNG TIN HỖ TRỢ</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6 pb-2">
          <div v-for="(inChargeItem, index) in inCharge" :key="index">
            <div class="d-flex justify-space-between pb-2">
              <AutocompleteInCharge
                return-object
                @change="setInCharge(index, $event)"
                :label="`Chọn người phụ trách ${index + 1}`"
                :inCharge="inChargeItem"
                :rules="[$rules.required]"
              />
              <v-icon class="ml-6" @click="removeInCharge(index)">mdi-trash-can</v-icon>
            </div>
          </div>
          <div class="d-flex justify-space-between mb-6">
            <v-spacer></v-spacer>
            <v-btn outlined color="blue darken-4" @click="addInCharge">Thêm</v-btn>
          </div>
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                v-model="subStatus"
                label="Trạng thái chi tiết"
                placeholder="Trạng thái chi tiết"
                :items="subStatusOptions"
                :rules="[$rules.required]"
                item-value="name"
                item-text="name"
                outlined
                validate-on-blur
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import AutocompleteInCharge from '../../components/basic/input/AutocompleteInCharge.vue'

export default {
  props: {
    dialog: Boolean,
    profile: Object,
  },
  components: { AutocompleteInCharge },
  data() {
    return {
      note: '',
      inCharge: [{}], // Initialize with an empty object
      valid: false,
      subStatus: '',
      subStatusOptions: [{ name: 'Đã liên hệ' }, { name: 'Đã phân tích vấn đề' }, { name: 'Đang giải quyết' }],
    }
  },
  watch: {
    profile: {
      handler(newVal) {
        if (newVal && newVal.inCharge && newVal.inCharge.length) {
          this.inCharge = newVal.inCharge
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    confirm() {
      if (this.$refs.form.validate()) {
        const data = {
          inCharge: this.inCharge.map(item => item._id),
          subStatus: this.subStatus,
          logNote: this.note,
        }
        this.$emit('inputConfirmed', { ...data })
      }
    },
    addInCharge() {
      this.inCharge.push({})
    },
    removeInCharge(index) {
      if (this.inCharge.length > 1) {
        this.inCharge.splice(index, 1)
      } else {
        this.$set(this.inCharge, index, {})
      }
    },
    setInCharge(index, data) {
      this.$set(this.inCharge, index, data)
    },
    cancel() {
      this.$emit('closeDialog')
    },
  },
}
</script>
